import { getTenantFrontendConfig } from '@/api/tenant';
import { openCustomerService } from '@/lib/customerService';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Register() {
  const navigate = useNavigate();
  const [brandName, setBrandName] = useState('天鼎AI');

  useEffect(() => {
    getTenantFrontendConfig().then((data) => setBrandName(data.brandName)).catch(() => {});
  }, []);

  return (
    <>
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mx-auto mb-4">
          <i className="ri-customer-service-2-line text-white text-3xl" />
        </div>
        <h1 className="text-xl font-bold text-foreground-950">领取 {brandName} 内测账号</h1>
        <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
          当前仅向受邀用户开放，暂不提供公开自助注册
        </p>
      </div>

      <div className="rounded-2xl border border-primary-100 bg-primary-50/60 p-4 mb-5">
        <div className="flex items-start gap-3">
          <i className="ri-shield-check-line text-primary-500 text-lg mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground-800">客服审核后发放账号</p>
            <p className="text-xs text-foreground-500 leading-relaxed mt-1">
              点击下方按钮添加客服，提交内测申请。客服二维码可按当前站点与渠道动态配置。
            </p>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => openCustomerService('register-route')}
        className="w-full py-3 bg-[#07c160] text-white rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap"
      >
        <i className="ri-wechat-line mr-1.5" />
        添加客服领取内测账号
      </button>

      <button
        type="button"
        onClick={() => navigate('/login')}
        className="w-full mt-3 py-3 border border-background-200 rounded-xl text-sm font-medium text-foreground-600 cursor-pointer"
      >
        已有账号，返回登录
      </button>

      <p className="text-[10px] text-foreground-400 text-center mt-6">
        本产品为学习与模拟演示工具，不构成投资建议
      </p>
    </>
  );
}
